import { ActivityTagAdditionalColumnCell } from "PFApp/activities/manage_roles/parts/additional_column_cell/activity_tag_additional_column_cell";
import { AdditionalColumnCellProps } from "PFApp/activities/manage_roles/parts/additional_column_cell/additional_column_cell.types";
import { RollForwardAdditionalColumnCell } from "PFApp/activities/manage_roles/parts/additional_column_cell/roll_forward_additional_column_cell";
import { StandardAdditionalColumnCell } from "PFApp/activities/manage_roles/parts/additional_column_cell/standard_additional_column_cell";
import { StateAdditionalColumnCell } from "PFApp/activities/manage_roles/parts/additional_column_cell/state_additional_column_cell";
import { VacanciesAdditionalColumnCell } from "PFApp/activities/manage_roles/parts/additional_column_cell/vacancies_additional_column_cell";

export const AdditionalColumnCell = (props: AdditionalColumnCellProps) => {
  const cellComponents = {
    source_role: RollForwardAdditionalColumnCell,
    target_roles: RollForwardAdditionalColumnCell,
    vacancies: VacanciesAdditionalColumnCell,
    activity_tag: ActivityTagAdditionalColumnCell,
    status: StateAdditionalColumnCell
  };

  const Component = cellComponents[props.column.name] ?? StandardAdditionalColumnCell;

  return <Component {...props} />;
};
